import React from 'react';
import { motion } from 'framer-motion';
import { Trophy, Star, Globe } from 'lucide-react';
const highlights = [{
  icon: <Trophy className="w-5 h-5" data-id="element-225" data-mp="2uc1hmkn3h67" />,
  text: 'First Professional Win'
}, {
  icon: <Star className="w-5 h-5" data-id="element-226" data-mp="3kzyq2sfwmpmr" />,
  text: '37 Saves in Season Opener'
}, {
  icon: <Globe className="w-5 h-5" data-id="element-227" data-mp="3pxqkpu7xopun" />,
  text: 'AIHL & Asia League (ALIH)'
}];
export const SuccessStoriesSection = () => {
  return <section id="success" className="py-24 bg-navy-800 relative overflow-hidden pt-[25px] pb-[25px]" data-id="element-228" data-mp="hiysiljmpxd9">
      {/* Subtle background accent */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-gold-500/5 rounded-full blur-3xl -mr-64 -mt-64 pointer-events-none" data-id="element-229" data-mp="7t5frh7r3c7f"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-ice-500/5 rounded-full blur-3xl -ml-48 -mb-48 pointer-events-none" data-id="element-230" data-mp="cq5ndwk90n0n"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 space-y-[10px]" data-id="element-231" data-mp="157rf3red2sv7">
        {/* Section Header */}
        <div className="text-center mb-16" data-id="element-232" data-mp="2dvtofzvuw1kq">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className="inline-flex items-center gap-2 px-4 py-1.5 bg-gold-500/10 border border-gold-500/20 rounded-full mb-6" data-id="element-233" data-mp="2duijhwqocns1">
            <Trophy className="w-4 h-4 text-gold-500" data-id="element-234" data-mp="2ro9s92wl03mp" />
            <span className="text-gold-500 text-sm font-bold tracking-wider uppercase" data-id="element-235" data-mp="2rnro7k3ogl48">
              Player Spotlight
            </span>
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-bold text-white mb-4 uppercase tracking-tight" data-id="element-236" data-mp="31lxojx9u5j6z">
            Success <span className="text-gold-500" data-id="element-237" data-mp="3gb3zf64mmk2m">Stories</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          delay: 0.2
        }} className="text-lg text-slate-300 max-w-2xl mx-auto" data-id="element-238" data-mp="3gd6tc18wgxcm">
            Real results from real players. See how UHD is helping athletes
            reach the next level.
          </motion.p>
        </div>

        {/* Featured Story Card */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.7
      }} className="bg-navy-900 border border-navy-700 rounded-sm overflow-hidden shadow-2xl" data-id="element-239" data-mp="gvyvrinyd2wv">
          <div className="grid grid-cols-1 lg:grid-cols-5" data-id="element-240" data-mp="1nfa0ewfnfug4">
            {/* Photo Side */}
            <div className="lg:col-span-2 relative h-72 sm:h-80 lg:h-auto min-h-[400px] bg-navy-700" data-id="element-241" data-mp="2l2a20fl40xxf">
              <img src="https://cdn.magicpatterns.com/uploads/4WEzZLkb68V13JKRFFDcVG/11233.png" alt="Ryo Murakami - Sydney Ice Dogs" className="w-full h-full object-cover object-top" data-id="element-242" data-mp="2g2npk8d3vlpo" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy-900 via-transparent to-transparent lg:bg-gradient-to-r lg:from-transparent lg:via-transparent lg:to-navy-900" data-id="element-243" data-mp="26b02skrhusuj"></div>

              {/* Name overlay on mobile */}
              <div className="absolute bottom-0 left-0 right-0 p-6 lg:hidden" data-id="element-244" data-mp="2jj8s4rjqv7e2">
                <span className="text-xs font-bold tracking-widest text-gold-500 uppercase block mb-1" data-id="element-245" data-mp="2nldhhe35thuw">
                  UHD Athlete
                </span>
                <h3 className="text-3xl font-black text-white" data-id="element-246" data-mp="29n5eopjfzmbt">Ryo Murakami</h3>
                <p className="text-ice-500 font-semibold text-sm" data-id="element-247" data-mp="2elqggtecee2d">
                  Goaltender — Sydney Ice Dogs (AIHL)
                </p>
              </div>
            </div>

            {/* Content Side */}
            <div className="lg:col-span-3 p-8 md:p-12 flex flex-col justify-center pt-[10px] pb-[10px]" data-id="element-248" data-mp="3781ga1u4kay4">
              {/* Name - desktop only */}
              <div className="hidden lg:block mb-8" data-id="element-249" data-mp="2xjjjrwsvoq0a">
                <span className="text-xs font-bold tracking-widest text-gold-500 uppercase block mb-2" data-id="element-250" data-mp="2xi8cvo44z24y">
                  UHD Athlete
                </span>
                <h3 className="text-4xl font-black text-white mb-2" data-id="element-251" data-mp="3pzkiw7k8lmzm">
                  Ryo Murakami
                </h3>
                <p className="text-ice-500 font-semibold uppercase tracking-wider" data-id="element-252" data-mp="1ek269xpal7xg">
                  Goaltender — Sydney Ice Dogs (AIHL)
                </p>
              </div>

              {/* Highlight Pills */}
              <div className="flex flex-wrap gap-3 mb-8" data-id="element-253" data-mp="1nbvp5qsamuq7">
                {highlights.map((item, i) => <motion.div key={i} initial={{
                opacity: 0,
                scale: 0.9
              }} whileInView={{
                opacity: 1,
                scale: 1
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.3 + i * 0.1
              }} className="flex items-center gap-2 px-4 py-2 bg-navy-800 border border-navy-700 rounded-full" data-id="element-254" data-mp="1jc3m1tlo5gs8" data-mpi={i}>
                    <span className="text-ice-500" data-id="element-255" data-mp="2b540v6m2iad5">{item.icon}</span>
                    <span className="text-sm font-semibold text-white" data-id="element-256" data-mp="18otpwtycxdbq">
                      {item.text}
                    </span>
                  </motion.div>)}
              </div>

              {/* Story */}
              <div className="space-y-4 text-slate-300 leading-relaxed mb-8" data-id="element-257" data-mp="1ho74g11c8s3b">
                <p data-id="element-258" data-mp="1mobjrnqifgry">
                  <span className="font-bold text-white" data-id="element-259" data-mp="1mmqplz83xzum">
                    Universal Hockey Development is proud to represent Ryo
                    Murakami!
                  </span>
                </p>
                <p data-id="element-260" data-mp="yzin1p22d4wa">
                  Our UHD Team would like to take a moment to congratulate Ryo
                  on earning his first professional win, which came in Sydney
                  with the Sydney Ice Dogs of the Australian Ice Hockey League
                  (AIHL). In the 2026 AIHL season opener Ryo made{' '}
                  <span className="text-gold-500 font-bold" data-id="element-261" data-mp="b965rnkxhvt1">37 saves</span> and
                  the Ice Dogs secured a big{' '}
                  <span className="text-gold-500 font-bold" data-id="element-262" data-mp="3pwv7r0orr2e">4–2 victory</span>{' '}
                  in the league-opening matchup—better known as the{' '}
                  <span className="italic text-white" data-id="element-263" data-mp="3px3tpfda1scd">"Battle of Sydney!"</span>
                </p>
                <p data-id="element-264" data-mp="3lwkyrcg3865y">
                  Since choosing Universal Hockey Development to support his
                  growth and development, Ryo has continued to elevate his game,
                  signing a contract for the 2026 AIHL season, and also earning
                  a paid tryout agreement with{' '}
                  <span className="text-white font-semibold" data-id="element-265" data-mp="376dqtqnpi5ji">
                    Nikko (Japan)
                  </span>{' '}
                  in the prestigious{' '}
                  <span className="text-white font-semibold" data-id="element-266" data-mp="2y6h7m4k35yvu">
                    Asia League Ice Hockey (ALIH)
                  </span>
                  , for the 2026-27 season.
                </p>
              </div>

              {/* Closing Quote */}
              <div className="bg-navy-800/60 border-l-4 border-gold-500 p-6 rounded-r-sm" data-id="element-267" data-mp="kzzdfjww45bj">
                <p className="text-white font-semibold italic" data-id="element-268" data-mp="pwg4alvh4xsb">
                  "Keep putting in the work, Ryo—UHD is proud of the drive,
                  discipline, and commitment you bring to the ice every day!"
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};